<template lang="pug">
#modal-editar-nota-fiscal
    el-dialog(
        width='600px',
        title='Editar',
        :visible.sync='mostrar',
        :close-on-click-modal='false',
        :before-close='fechar'
    )
        el-form(label-position='top')
            el-row(:gutter="20")
                el-col(:span="12")
                    el-form-item
                        template(slot='label')
                            span Número da nota fiscal

                        el-input(v-model='numeroNotaFiscal', placeholder='Número da nota fiscal', type='number')
                el-col(:span="12")
                    el-form-item
                        template(slot='label')
                            span Material

                        el-input(v-model='materialDescricao', placeholder='Material')
            
            el-row(:gutter="20")
                el-col(:span="12")
                    el-form-item
                        template(slot='label')
                            span Quantidade

                        el-input(v-model='quantidade', maxlength='200', placeholder='Quantidade', type='number')
                
                el-col(:span="12")
                    el-form-item
                        template(slot='label')
                            span Data de entrada na usina

                        el-date-picker(
                            v-model='dataEmissao',
                            placement='bottom-start',
                            type='date',
                            placeholder='Data de entrada na usina',
                            format='dd/MM/yyyy'
                        )

        footer.espaco(slot='footer')
            BaseButton(type='default', @click='fechar') Cancelar

            BaseButton(
                type='primary',
                @click='salvar'
                :disabled='!checkCamposValidos()',
            ) Salvar

</template>

<script>
import RastreabilidadeNotaFiscalService from '@/services/RastreabilidadeNotaFiscalService';
import BaseButton from '@/components/vegaComponents/BaseButton.vue';

export default {
    name: 'ModalEditarNotaFiscal',
    components: {
        BaseButton
    },
    emits: ['atualizarDados'],
    props: {
        mostrar: {
            type: Boolean,
            required: true
        },

        editar: {
            type: Boolean,
            required: false,
            default: false
        },

        dados: {
            type: Object,
            required: false,
            default: null
        }
    },

    data() {
        return {
            id: '',
            numeroNotaFiscal: '',
            materialDescricao: '',
            codigoLiberacao: '',
            quantidade: '',
            dataEmissao: ''
        };
    },

    watch: {
        mostrar() {
            if (this.dados) {
                this.id = this.dados.id;
                this.numeroNotaFiscal = this.dados.numeroNotaFiscal;
                this.materialDescricao = this.dados.materialDescricao;
                this.quantidade = this.dados.quantidade;

                let dataSplit = this.dados.dataEmissao.split('/');
                let padraoDatePicker = `${dataSplit[1]}/${dataSplit[0]}/${dataSplit[2]}`;

                this.dataEmissao = new Date(padraoDatePicker);
            }
        }
    },

    methods: {
        fechar() {
            this.id = '';
            this.numeroNotaFiscal = '';
            this.materialDescricao = '';
            this.quantidade = '';
            this.dataEmissao = '';

            this.$emit('fechar');
        },

        checkCamposValidos() {
            if (
                this.numeroNotaFiscal !== '' &
                this.materialDescricao !== '' &
                this.quantidade !== '' &
                this.dataEmissao !== ''
                ) {
                    return true;
                }

            return false;
        },

        async salvar() {
            try {
                await RastreabilidadeNotaFiscalService.editarNotaFiscal({
                    id: this.dados.id,
                    numeroNotaFiscal: this.numeroNotaFiscal,
                    materialDescricao: this.materialDescricao,
                    quantidade: this.quantidade,
                    dataEmissao: this.dataEmissao.toLocaleDateString('pt-BR')
                });

                this.fechar();
                this.$emit('atualizarDados');

                this.$notify.success({
                    message: 'Nota Fiscal editada com sucesso'
                });
            } catch (e) {
                this.$notify.error({
                    message: e.response.data.message
                });
            }
        }
    }
};
</script>

<style lang="scss">
footer {
    display: flex;
    justify-content: space-between;
}

.invalido {
    color: var(--danger);
}

.espaco {
    display: flex;
}

.el-date-editor.el-input {
    width: 100%;
}
</style>
